import { useState, useEffect } from 'react';
import { getContainer } from '@framework/di/getContainer';
import { getErrorMessage } from '@framework/message/Mapper/getMessage';
import { AlertManager } from '@dealroadshow/uikit-alert';
import LandingRepository from '@/dataroom/infrastructure/repository/LandingRepository';
import { currencyCodes } from '@framework/ui/Pages/Landing/Sections/constants';
import { ILandingCurrency } from '@framework/ui/Pages/Landing/Sections/Form/CurrenciesSelect/ILandingCurrency';

const useCurrencies = (defaultCurrency = 'USD') => {
  const container = getContainer();

  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [currency, setCurrency] = useState<ILandingCurrency | null>(null);
  const [collection, setCollection] = useState<ILandingCurrency[]>([]);

  useEffect(() => {
    setCurrency(collection.find((item) => item.label === defaultCurrency)!);
  }, [collection]);

  const getCurrencies = async () => {
    setIsFetching(true);

    try {
      const landingRepository = container.get<LandingRepository>(LandingRepository);
      const response = await landingRepository.getCurrencies();

      const collection = response.map(({ id, abbreviation }) => ({
        value: id,
        label: abbreviation,
        countryCode: (currencyCodes as Record<string, string>)[abbreviation],
      }));

      setCollection(collection);
    } catch (error) {
      AlertManager.error(getErrorMessage(error));
    } finally {
      setIsFetching(false);
    }
  };

  return {
    isFetching,
    collection,
    currency,
    setCurrency,
    getCurrencies,
  };
};

export default useCurrencies;
